import { GTFS_PROVIDER_TYPE } from '../util/gtfs-config';

export const SIRI_PROVIDER_TYPE = 'siri';

/** Provider types with their own route tree and UI, under
 *  /admin/providers/<type>/:providerId. Any other type uses the generic tree
 *  at /admin/providers/:providerId. Type is unique per provider (core 409s on
 *  a duplicate), so each tree holds at most one provider. */
export const TYPED_PROVIDER_ROUTES: readonly string[] = [SIRI_PROVIDER_TYPE, GTFS_PROVIDER_TYPE];

/** The route-tree type for a provider type: itself if it has a dedicated UI, else null (generic). */
export function routeTypeFor(providerType: string): string | null {
  return TYPED_PROVIDER_ROUTES.includes(providerType) ? providerType : null;
}

/** Router commands for a provider's base page (its Feeds tab). */
export function providerBasePath(routeType: string | null, providerId: string): string[] {
  return routeType ? ['/admin', 'providers', routeType, providerId] : ['/admin', 'providers', providerId];
}

/** Feeds are only ever created against/managed for the full tenant set, so a
 *  single page is fetched — page size chosen generously above realistic tenant
 *  counts rather than paginating a dropdown. */
export const TENANT_PICKER_SIZE = 200;
